import { matchesAppRoute, isTeacherAdminBigTopRoute } from './bigTopRollout.js';

/**
 * Master switch for the standardized teacher workspace shell.
 */
export const ENABLE_TEACHER_VIEW_THEME = true;

/** Teacher admin routes that use TeacherPageShell (not big-top cream). */
export const TEACHER_VIEW_ROUTE_PATHS = [
  '/manageClasses',
  '/createClass',
  '/addStudentsToClass',
  '/purchasedSeats',
  '/classSeatPricing',
  '/recentClassActivity',
  '/recentClassReviewActivity',
  '/skillSelector',
  '/skillProgress',
  '/editClass',
  '/viewClassProgress',
];

export function isTeacherViewRoute(pathname) {
  if (!ENABLE_TEACHER_VIEW_THEME) {
    return false;
  }

  return TEACHER_VIEW_ROUTE_PATHS.some((route) => matchesAppRoute(pathname, route));
}

/** True when the teacher admin nav item should show as active. */
export function isTeacherAdminNavRoute(pathname) {
  return isTeacherViewRoute(pathname);
}

export function isBackstageLoaderRoute(pathname) {
  return isTeacherViewRoute(pathname) || isTeacherAdminBigTopRoute(pathname);
}

export const BACKSTAGE_LOADER_MESSAGE = 'Heading backstage . . .';
